import { render, staticRenderFns } from "./noticeListModalV2.vue?vue&type=template&id=31d34839&"
import script from "./noticeListModalV2.vue?vue&type=script&lang=js&"
export * from "./noticeListModalV2.vue?vue&type=script&lang=js&"
import style0 from "./noticeListModalV2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports